<template>
<div>
  <div class="nav-admin" v-if="token">
    <div class="nav-spacer"></div>
    <div class="nav-center">
      <div class="sala">
        <span class="text" @click="getPage('SALA')">{{ $t('sala') }}</span>
      </div>
      <div class="gestionale">
        <span class="text" @click="getPage('GESTIONALE')">{{ $t('gestionale') }}</span>
      </div>
    </div>
    <div class="logout">
      <span class="text" @click="logout">{{ $t('logout') }}</span>
    </div>
  </div>
  <div class = "main-sala" v-if= 'page == "SALA"'>
  <Sala   v-bind:token ="token" />
  </div>
  <div class = "main-gestionale" v-if= 'page == "GESTIONALE"'>
  <Gestionale v-bind:token="token" />
  </div>
</div>
</template>

<script>
import Sala from '@/components/Sala.vue'
import Gestionale from '@/components/Gestionale.vue'
export default {
  name: 'NavBar',
    components: {
    Sala,
    Gestionale
  },
  data: function () {
    return {
        token:'',
        page:'',
    }
  },
    methods: {
      getToken () {
         this.token = this.$route.params.token || localStorage.token;
      },
      getPage (page) {
        this.page = page;
      },
      logout () {
        localStorage.removeItem('token');
        this.token = '';
        this.page = '';
        this.$router.push({ name:"Home"})
      }
  },
  beforeMount() {
    this.getToken()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-admin {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.nav-spacer {
  flex: 1;
}

.nav-center {
  display: flex;
  gap: 30px;
}

.logout {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 600px) {
  .nav-admin {
    padding: 10px;
    gap: 10px;
  }
  .nav-center {
    gap: 15px;
  }
  .nav-spacer {
    display: none;
  }
  .logout {
    flex: none;
  }
}

.text {
  color: rgb(0, 0, 0);
  cursor: pointer;
}

.main-sala {
  height: 78vh;
}
</style>